import { render, staticRenderFns } from "./prosecutors.vue?vue&type=template&id=0bd5982b&scoped=true"
import script from "./prosecutors.vue?vue&type=script&lang=js"
export * from "./prosecutors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5982b",
  null
  
)

export default component.exports